export const CsvType = {
    DETAILS: 'DETAILS',
    LOG: 'LOG',
    REPORT: 'REPORT',
};
